import {PREFIX_EXT_TERMS} from '@i18n/helpers/terms/constants'

const getJustoTerms = terms => {
  return Object.keys(terms).filter(term => !term.startsWith(PREFIX_EXT_TERMS))
}

export default getJustoTerms
